import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/remote-config';

const config = {
  apiKey: "AIzaSyC-VDVnych2J-1UonBkmfO8_iWGkbSQvxo",
  authDomain: "barbera-24348.firebaseapp.com",
  projectId: "barbera-24348",
  storageBucket: "barbera-24348.firebasestorage.app",
  messagingSenderId: "171928407661",
  appId: "1:171928407661:web:49ce912b0dd9a3df39b964",
  measurementId: "G-H5L56Y7Z4P"
};

firebase.initializeApp(config);
let auth = firebase.auth();
let remoteConfig = firebase.remoteConfig();
remoteConfig.settings.minimumFetchIntervalMillis = 0;
export { auth, firebase, remoteConfig };